import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiCall, saveFile } from './../../components/special/apiCall';
import {useErrorContext} from 'components/messages/ErrorBox';
import InputDate from './../../components/input/InputDate';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';



const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const OutlaidCostReport = (props)  => {
    const [reportData, setReportData] = useState({
        fromDate : new Date(),
        toDate : new Date()
    });      
    const setCheckErrorItems = useErrorContext();
    const setIsPageLoading = usePageLoadingContext();
    const { t } = useLocale();


    const isResultOk = (obj) => {
        if ((obj != null) && (obj.error != undefined)){
            setCheckErrorItems([obj]);
            return null;
        }
        return obj;
    }

    const createReport = async () => {
        setIsPageLoading(true);
        const data = await apiCall(`${BASE_URL}/features/report/outlaidcostdata`,{ method: 'post', data: {fromDate: reportData.fromDate, toDate: reportData.toDate}});
        if (isResultOk(data)){
            saveFile(data.fileData, data.fileName, data.contentType);
        }
        setIsPageLoading(false);
    }


  return (
    <div>            
      <h1 className="text-red text-32">{t("Útlagður kostnaður skýrsla")}</h1>           
      <div>
        <div className="grid box" id="skref1">
            <div className="col s1of1">
                <div className="grid">
                    <div className="col s1of2">
                        <h3>{t("Dagsetning")}</h3>
                    </div>
                    <div className="col s1of2 text-right">
                        <p>{t("Skref") + " 1 " + t("af") + " 1 "}</p>
                    </div>
                </div>
            </div>
            <div className="col s1of1">
                <div className="grid">
                    <div className="form col s1of2">
                        <p>{t("Taka út skýrslu fyrir þann útlagðan kostnað sem hafa verið framkvæmd á ákveðinni dagsetningu.")}</p>                        
                        <div className="col s1of1">
                            <div className="grid">
                                <div className="form col s2of12 text-center">
                                    Frá
                                </div>
                                <div className="form col s4of12">
                                <InputDate value={reportData.fromDate}  onChange={(value) => setReportData({...reportData, fromDate : value})} />                                                            
                                </div>
                                <div className="form col s2of12 text-center">
                                    Til
                                </div>
                                <div className="form col s4of12">
                                    <InputDate value={reportData.toDate}  onChange={(value) => setReportData({...reportData, toDate : value})} />                                                            
                                </div>
                                <div className="form col s2of12">

                                </div>
                            </div>
                        </div>
                    </div>            
                    <div className="col s1of2 text-right">
                        
                    </div>
                </div>
            </div>
            <div className="col s1of1 text-right">
                <button className="button blue" onClick={createReport}>{t("Útbúa skýrslu í excel")}</button>                        
            </div>
        </div>    
        </div>
    </div>
  );
};
